import { Component } from 'opus-angular-seed-core';
import template from './template.html';

/**
 * Tools for going through the translation review of the selected language.
 */
@Component({
    bindings: {
        canCompare: '<',
        isComparing: '<',
        compareLabel: '<',
        remainingCount: '<',
        nextLabel: '<',
        isDisabled: '<',
        onToggleCompare: '&',
        onNext: '&'
    },
    template
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/authoringTool/editor/reviewTools/index.js